import { ApiClientAxios, apiFactoryConfig } from "@repo/api";
import { useMutation, UseMutationOptions, useQueryClient } from "@tanstack/react-query";
import { type AxiosResponse } from "axios";

export type QuestionnairePdfMutationRequest = {
    contractId: string;
    zZJInformationRequest: ApiClientAxios.ZZJInformationRequest;
};

export const useQuestionnairePdfMutation = (
    options?: Partial<UseMutationOptions<Blob, Error, QuestionnairePdfMutationRequest>>,
) => {
    const queryClient = useQueryClient();
    const api = ApiClientAxios.ContractsDpsApiFactory(...apiFactoryConfig);

    return useMutation<Blob, Error, QuestionnairePdfMutationRequest>({
        mutationKey: ["questionnairePdf"], // base key (variables appended below for cache lookups)
        mutationFn: async ({ contractId, zZJInformationRequest }: QuestionnairePdfMutationRequest) => {
            const key = ["questionnairePdf", contractId, JSON.stringify({ zZJInformationRequest })];
            const cached = queryClient.getQueryData<Blob>(key);
            if (cached) {
                return cached; // short-circuit with cached data
            }

            const response = (await api.getDpsZzjPdfPost(contractId, zZJInformationRequest, {
                responseType: "blob", // otherwise response.data is a string
            })) as AxiosResponse<Blob>;

            // store in query cache so repeated mutate calls with same variables (QuestionnairePdfMutationRequest) reuse result
            queryClient.setQueryData(key, response.data);
            return response.data;
        },
        ...options,
    });
};
